'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalMall = function MdLocalMall(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 21.6c4.6 0 8.4-3.6 8.4-8.2h-3.4c0 2.7-2.3 5-5 5s-5-2.3-5-5h-3.4c0 4.6 3.8 8.2 8.4 8.2z m0-16.6c-2.7 0-5 2.3-5 5h10c0-2.7-2.3-5-5-5z m11.6 5c1.8 0 3.4 1.6 3.4 3.4v20c0 1.8-1.6 3.2-3.4 3.2h-23.2c-1.8 0-3.4-1.4-3.4-3.2v-20c0-1.8 1.6-3.4 3.4-3.4h3.2c0-4.6 3.8-8.4 8.4-8.4s8.4 3.8 8.4 8.4h3.2z' })
        )
    );
};

exports.default = MdLocalMall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-mall.js
// module id = 3261
// module chunks = 0